import React from 'react';
import {useTranslation} from 'react-i18next';

import {YesNoModal} from '../../elements/YesNoModal';

/**
 * La pregunta que sigue a subir el knob: «hay N hechos esperando tu ok que se pueden aprobar
 * automáticamente. ¿Los apruebo?» (card 8uu3IdNd, punto 4).
 *
 * Es `YesNoModal` y no un aviso propio por la misma razón que «Aprobar todo»: es la única acción de
 * esta pantalla que compromete N hechos de una, y la confirmación tiene que decir CUÁNTOS son —ese
 * es el dato que falta para decidir— y nombrar la posición que los deja entrar, porque el usuario
 * la acaba de mover y todavía no vio qué hace.
 *
 * Sin oferta no renderiza nada: el `isOpen` en `false` de `YesNoModal` alcanzaría, pero devolver
 * `null` deja claro que ésta no es una pieza fija de la pantalla.
 */
export function AutonomyRaiseOfferModal({offer, busy, onYes, onNo}) {
    const {t, i18n} = useTranslation();
    if (!offer) return null;
    // ⚠️ El número se interpola YA FORMATEADO, en una variable aparte (`shown`), y `count` queda sólo
    // para elegir el plural: i18next no formatea, así que una cola grande se leía «quedan 12260 más»
    // (QA-VIS-knob2-14). El idioma lo da la app, no el navegador: en `es` son puntos de miles.
    const shownNumber = (value) => Number(value).toLocaleString(i18n.language);
    return (
        <YesNoModal
            skipRenderButton
            isOpen
            title={t('memory_autonomy.raise_offer_title')}
            question={[
                t('memory_autonomy.raise_offer_question', {
                    count: offer.count,
                    shown: shownNumber(offer.count),
                    level: t(`memory_autonomy.level.${offer.level}`),
                    interpolation: {escapeValue: false},
                }),
                // Los que quedan afuera se NOMBRAN, no se omiten: si no, el «Aprobar todo» de al
                // lado dice otro número y la pantalla parece contradecirse. Se compone acá y no
                // dentro de la clave porque i18next pluraliza por UNA sola variable `count`, y
                // esta frase tiene dos números.
                //
                // ⚠️ Con `truncated` la frase es OTRA: ahí el resto no son «los que necesitan que
                // los mires» —calificaron más de los que la tanda resuelve, así que entre ellos hay
                // hechos que habrían entrado solos— y no tenemos con qué separar los dos grupos.
                // Lo único honesto es decir que quedan en la cola (hallazgo C-knob-13).
                offer.rest > 0
                    ? t(offer.truncated
                        ? 'memory_autonomy.raise_offer_rest_capped'
                        : 'memory_autonomy.raise_offer_rest',
                    {count: offer.rest, shown: shownNumber(offer.rest)})
                    : null,
            ].filter(Boolean).join(' ')}
            isSaving={busy}
            onYesAnswer={onYes}
            onNoAnswer={onNo}
        />
    );
}

export default AutonomyRaiseOfferModal;
